import { createEntityAdapter } from '@reduxjs/toolkit';
import { ICollection } from '@tacans/shared-marketplace-layer';

export const HighlightedCollectionsAdapter = createEntityAdapter<ICollection>();
